import { inject, Injectable } from '@angular/core';
import { Apis } from '../apis/apis';
import { UserI } from '../../../views/shared/interfaces/user.interface';

@Injectable({
  providedIn: 'root',
})
export class SharedApis {
  private readonly apis = inject(Apis);

  findLoggedInUser() {
    return this.apis.get<UserI>('users/logged-in-user');
  }
}
